module.exports = __webpack_public_path__ + "static/media/business-and-trade.4b550622.svg";